import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
	name: 'userInitials',
	standalone: true
})
export class UserInitialsPipe implements PipeTransform {

	constructor(private userService: UserService) { }

	transform(userFullName: string | null | undefined) {
		return this.userService.getInitials(userFullName) ?? '';
	}
}